module.exports = __webpack_public_path__ + "static/media/1.3fc808e3.png";